<template>
  <div>
    <a-row class="statistics" type="flex" justify="space-between">
      <a-col :span="4">
        <a-card>
          <p class="mb-0 size3">流程数量</p>
          <a style="font-size: 40px">{{ useCount }}</a>
          <a-icon type="appstore"/>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card>
          <p class="mb-0 size3">待办数量</p>
          <a style="font-size: 40px">{{ taskCount }}</a>
          <a-icon type="cluster"/>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card>
          <p class="mb-0 size3">已办数量</p>
          <a style="font-size: 40px">{{ passTaskCount }}</a>
          <a-icon type="audit"/>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card>
          <p class="mb-0 size3">实例数量</p>
          <a style="font-size: 40px">{{ instanceTotal }}</a>
          <a-icon type="file-done"/>
        </a-card>
      </a-col>
      <a-col :span="4">
        <a-card>
          <p class="mb-0 size3">已完成实例</p>
          <a style="font-size: 40px">{{ completeCount }}</a>
          <a-icon type="fund"/>
        </a-card>
      </a-col>
    </a-row>
    <a-row class="mt-3" :gutter="16">
      <a-col :span="12">
        <a-card title="处理量">
          <a-radio-group
              v-model="topQuery"
              @change="topOnChange"
          >
            <a-radio :value="1"> 组织</a-radio>
            <a-radio :value="2"> 个人</a-radio>
          </a-radio-group>
          <barchart
              ref="firstBarchart"
              :id="'firstBarchart'"
              :style="{
            width: '100%',
            height: '300px',
          }"
          />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="已完成">
          <a-radio-group
              v-model="completeQuery"
              @change="completeOnChange"
          >
            <a-radio :value="1"> 文档类别</a-radio>
            <a-radio :value="2"> 流程名称</a-radio>
          </a-radio-group>
          <barchart
              ref="completechars"
              :id="'completechars'"
              :style="{
            width: '100%',
            height: '300px',
          }"
          />
        </a-card>
      </a-col>
    </a-row>

    <a-row class="mt-3" :gutter="16">
      <a-col :span="12">
        <a-card title="待办">
          <a-radio-group
              v-model="taskQuery"
              @change="taskOnChange"
          >
            <a-radio :value="1"> 文档类别</a-radio>
            <a-radio :value="2"> 流程名称</a-radio>
          </a-radio-group>
          <barchart
              ref="secondBarchart"
              :id="'secondBarchart'"
              :style="{
            width: '100%',
            height: '300px',
          }"
          />
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card title="已办">
          <a-radio-group
              v-model="passQuery"
              @change="passOnChange">
            <a-radio :value="1"> 文档类别</a-radio>
            <a-radio :value="2"> 流程名称</a-radio>
          </a-radio-group>
          <barchart
              ref="threeBarchart"
              :id="'threeBarchart'"
              :style="{
            width: '100%',
            height: '300px',}"/>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import barchart from './barchart'

export default {
  components: {
    barchart
  },
  created () {
    this.getUseCount()
    this.getInstanceCount()
    this.getTask()
    this.getPassTask()
    this.getTopDept()
    this.getTaskCate()
    this.getPassCate()
    this.getCompleteCate()
  },
  computed: {},
  data () {
    return {
      // 流程数量
      useCount: 0,
      // 流程实例数量
      instanceTotal: 0,
      // 流程完成实例数量
      completeCount: 0,
      // 流程待办数量
      taskCount: 0,
      // 流程经办数量
      passTaskCount: 0,
      // top查询条件
      topQuery: 1,
      // 待办查询条件
      taskQuery: 1,
      // 已办查询条件
      passQuery: 1,
      // 已完成实例
      completeQuery: 1
    }
  },
  methods: {
    // 已完成 请求方法
    getCompleteCate () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_complete_task_count_by_cate.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.completechars.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    getCompleteProcess () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_complete_task_count_by_process.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.completechars.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    // 已办 请求方法
    getPassCate () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_pass_task_count_by_cate.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.threeBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    getPassProcess () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_pass_task_count_by_process.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.threeBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    // 待办 请求方法
    getTaskCate () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_task_count_by_cate.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.secondBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    getTaskProcess () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_pass_task_count_by_process.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.secondBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    // top10 组织请求方法
    getTopDept () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_dept_pass_task_count.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.firstBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    // top10 个人请求方法
    getTopUser () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_top_user_pass_task_count.json')
        .then((res) => {
          if (res.result) {
            var xAxisData = []
            var seriesData = []
            for (let index = 0; index < res.result.length; index++) {
              const element = res.result[index]
              if (element.name) {
                xAxisData.push(element.name)
              }
              if (element.total) {
                seriesData.push(element.total)
              }
            }
            that.$refs.firstBarchart.refreshData(xAxisData, seriesData, true)
          }
        })
    },
    // 各条件单选触发方法
    topOnChange (e) {
      this.topQuery = e.target.value
      if (this.topQuery === 1) {
        this.getTopDept()
      } else {
        this.getTopUser()
      }
    },
    taskOnChange (e) {
      this.taskQuery = e.target.value
      if (this.taskQuery === 1) {
        this.getTaskCate()
      } else {
        this.getTaskProcess()
      }
    },
    passOnChange (e) {
      this.passQuery = e.target.value
      if (this.passQuery === 1) {
        this.getPassCate()
      } else {
        this.getPassProcess()
      }
    },
    completeOnChange (e) {
      this.completeQuery = e.target.value
      if (this.completeQuery === 1) {
        this.getCompleteCate()
      } else {
        this.getCompleteProcess()
      }
    },
    // 获取流程数量
    getUseCount () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_workflow_count_by_state.json')
        .then((res) => {
          if (res.result) {
            that.useCount = res.result.useCount
          }
        })
    },
    // 获取流程实例数量
    getInstanceCount () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_process_instance_count_by_state.json')
        .then((res) => {
          if (res.result) {
            that.instanceTotal = res.result.totalCount
            that.completeCount = res.result.completeCount
          }
        })
    },
    // 获取流程待办数量
    getTask () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_task_count.json')
        .then((res) => {
          if (res.result) {
            that.taskCount = res.result
          }
        })
    },
    // 获取流程经办数量
    getPassTask () {
      const that = this
      this.$http
        .get('/api/1/workflow/stats/get_pass_task_count.json')
        .then((res) => {
          if (res.result) {
            that.passTaskCount = res.result
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.mt-3 {
  margin-top: 12px;
}

/deep/ .statistics .ant-card {
  overflow: hidden;
}

/deep/ .statistics .ant-col-4 {
  width: 19%;
}

/deep/ .statistics .ant-card-body {
  padding: 0 24px 24px 24px;
}

.statistics .anticon {
  position: absolute;
  right: 20px;
  // bottom: -12px;
  font-size: 80px;
  opacity: 0.1;
  color: #1890ff;
  top: 36px;
}

.statistics p {
  margin-top: 20px;
  margin-bottom: 20px;
}

.tab-head {
  background-color: #0000004a;
  margin: 8px;
}

.span-title {
  margin-left: 10px;
  font-weight: bold;
  color: black;
}

.h-title {
  font-weight: bold;
  color: black;
  text-align: center;
  margin-top: 25px
}

/deep/ .ant-radio-group {
  margin-top: -62px;
  position: absolute;
  right: 0;
}

</style>
